module.exports = __webpack_public_path__ + "static/media/24.c736bff2.mp3";